// extracted by mini-css-extract-plugin
export default {"container":"PcpConcernList_container__GUU3-","list":"PcpConcernList_list__rv1Ni"};